module.exports = __webpack_public_path__ + "static/media/logo_transparent.399ea8e3.png";